import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { AppComponent } from './app.component';
import {
    APP,
    LOGIN,
    PAYROLL,
    EMPLOYEES,
    CONTRACTORS,
    TAXATION,
    REPORTS,
    ONBOARDING,
    GO,
    GO_SSO,
    GO_EMAILVERIFICATION,
    GO_LINK,
    SETTINGS
} from './@core/router/app-states';
import { environment } from '@environments/environment';
import { appRouterConfigFn } from '@core/router/app-router-config';
import { EmptyComponent } from './components/empty/empty.component';
import { GoComponent } from './features/go/go.component';
import { SettingsModule } from './features/settings/settings.module';

const APP_STATES: Ng2StateDeclaration[] = [
    {
        name: APP,
        url: '',
        views: {
            '@': {
                component: AppComponent,
            },
        },
        redirectTo: {
            state: environment.paths.home.employer.state
        }
    },
    {
        name: GO,
        url: '/go',
        views: {
            '@': {
                component: EmptyComponent,
            },
        },
    },
    {
        name: GO_SSO,
        url: '/sso?sso_id,mode,service_provider',
        views: {
            '@': {
                component: GoComponent,
            },
        },
    },
    {
        name: 'go.login.**',
        url: '/login',
        loadChildren: () =>
            import('./features/login/login.module').then((m) => m.LoginModule),
    },
    {
        name: GO_EMAILVERIFICATION,
        url: '/email_verify',
        views: {
            '@': {
                component: EmptyComponent,
            },
        },
    },
    {
        name: GO_LINK,
        url: '/link/:token',
        views: {
            '@': {
                component: EmptyComponent,
            },
        },
    },
    {
        name:`${ LOGIN }.**`,
        url: `/${ LOGIN }`,
        loadChildren: () => import('./features/login/login.module').then((module) =>  module.LoginModule)
    },
    {
        name: `${ PAYROLL }.**`,
        url: `/${ PAYROLL }`,
        loadChildren: () => import('./features/payroll/payroll.module').then((module) =>  module.PayrollModule)
    },
    {
        name: `${ EMPLOYEES }.**`,
        url: `/${ EMPLOYEES }`,
        loadChildren: () => import('./features/employees/employees.module').then((module) =>  module.EmployeesModule)
    },
    {
        name: `${ CONTRACTORS }.**`,
        url: `/${ CONTRACTORS }`,
        loadChildren: () => import('./features/contractors/contractors.module').then((module) =>  module.ContractorsModule)
    },
    {
        name: `${ TAXATION }.**`,
        url: `/${ TAXATION }`,
        loadChildren: () => import('./features/taxation/taxation.module').then((module) =>  module.TaxationModule)
    },
    {
        name: `${ REPORTS }.**`,
        url: `/${ REPORTS }`,
        loadChildren: () => import('./features/reports/reports.module').then((module) =>  module.ReportsModule)
    },
    {
        name: `${ SETTINGS }.**`,
        url: `/${ SETTINGS }`,
        loadChildren: () => import('./features/settings/settings.module').then((module) =>  module.SettingsModule)
    },
    {
        name: `${ ONBOARDING }.**`,
        url: `/${ ONBOARDING }`,
        loadChildren: () => import('./features/onboarding/onboarding.module').then((module) =>  module.OnboardingModule)
    }
];

export const appRoutes = UIRouterModule.forRoot({
    states: APP_STATES,
    otherwise: '/error/404',
    useHash: true,
    config: appRouterConfigFn,
});
